import type { RelatedCategory } from '../types';

/**
 * The structural minimum both cat-service-api's and UPS's navigation blocks satisfy, so the one
 * rule serves both sources.
 */
interface NavigationBlockLike {
  options: { rel: string | null; title: string | null }[];
  type: string;
}

/**
 * The related-categories carousel is the only navigation block the PDP renders. Options without a
 * `rel` are dropped: `rel` is the site-relative path the carousel links to, and an option without
 * one has nowhere to go.
 */
export const extractRelatedCategories = (navigation: NavigationBlockLike[]): RelatedCategory[] =>
  (navigation.find((block) => block.type === 'relatedCategories')?.options ?? [])
    .filter((option) => option.rel)
    .map((option) => ({ href: option.rel!, text: option.title ?? '' }));
